import { ReactNode } from 'react';

const FlexContainer = ({ children }: { children: ReactNode }) => (
    <div className="landing-container__form">{children}</div>
);

export default FlexContainer;
